export const BORDERS = '1px solid #dddddd'
export const PADDING = 10
export const SIDEBAR_WIDTH = 230
export const HEADER_HEIGHT = 40
export const GRID_BACKGROUND_COLOR = '#F6F6F8'
